import React from 'react';
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next';
//MUI
import { Button, Typography, ThemeProvider, responsiveFontSizes, Box } from '@mui/material';
import {createTheme} from '@mui/material/styles';

//Assets
import sznszt from '../Assets/sznszt.png'


let theme = createTheme();
theme = responsiveFontSizes(theme);


function Home() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <>
      <div style={{ position: 'relative' }}>      
        <img src={sznszt} style={{ width: "100%", opacity: '0.7' }}/>
        <Box sx ={{
          position: 'absolute',
          top: '30vh',
          left: '5vw',
          right: '5vw', 
          zIndex: '100', 
          borderRadius: "15px", 
          backgroundColor: '#032b3b', 
          padding:'20px', 
          fontWeight: 'bolder',
          textAlign: 'center',
          maxWidth: '90%',
          margin: '0 auto', // Center horizontally 
          [theme.breakpoints.up('md')]: {
            top: '35vh',
            left: '15vw',
            right: '15vw',
            maxWidth: '60%',
          }
        }}>
          <ThemeProvider theme={theme}>
              <Typography variant='h2' sx={{ 
                color: '#2492be', 
                fontSize: '1.2rem', 
                [theme.breakpoints.up('sm')]: { fontSize: '1.5rem' },
                [theme.breakpoints.up('md')]: { fontSize: '2rem' }
              }}>
                {t('Home.Discover')} <span style={{ color: 'green', wordWrap: 'break-word' }}> {t('Home.Szekelyfold')} </span>                 
              </Typography>
              
            <Typography variant='h5' sx={{ 
              color: '#b0bcc0', 
              fontSize: '0.9rem', 
              [theme.breakpoints.up('sm')]: { fontSize: '1.2rem' },
              [theme.breakpoints.up('md')]: { fontSize: '1.5rem' } 
            }}>{t('Home.ExpandDictionary')}</Typography>
            <Typography variant='h5' sx={{ 
              color: '#b0bcc0', 
              fontSize: '0.9rem', 
              [theme.breakpoints.up('sm')]: { fontSize: '1.2rem' },
              [theme.breakpoints.up('md')]: { fontSize: '1.5rem' } 
            }}>{t('Home.RegisterAcademy')}</Typography>
            <Typography variant='h5' sx={{ 
              color: '#b0bcc0', 
              fontSize: '0.9rem', 
              [theme.breakpoints.up('sm')]: { fontSize: '1.2rem' },
              [theme.breakpoints.up('md')]: { fontSize: '1.5rem' } 
            }}>{t('Home.MapCompany')}</Typography>
            <Typography variant='h5' sx={{ 
              color: '#b0bcc0', 
              fontSize: '0.9rem', 
              [theme.breakpoints.up('sm')]: { fontSize: '1.2rem' },
              [theme.breakpoints.up('md')]: { fontSize: '1.5rem' } 
            }}>{t('Home.FindMaster')}</Typography>
            <Typography variant='h5' sx={{ 
              color: '#b0bcc0', 
              fontSize: '0.9rem', 
              [theme.breakpoints.up('sm')]: { fontSize: '1.2rem' },
              [theme.breakpoints.up('md')]: { fontSize: '1.5rem' } 
            }}>{t('Home.PassOn')}</Typography>
            <Button 
              variant="contained" 
              onClick={()=>navigate(`/${i18n.language}/terkep`)}  
              sx={{ fontSize: '1.2rem', 
              borderRadius: "15px", 
              backgroundColor: '#2492be', 
              marginTop: '1rem', 
              boxShadow: '1px 1px 1px white',
              [theme.breakpoints.up('md')]: { 
                fontSize: '3rem',
                marginTop: '2rem',
              } 
              }}
            >
              &gt;&gt; {t('Header.InteractiveMap').toUpperCase()}
            </Button>
          </ThemeProvider>
        </Box>
      </div>
    </>
  );
}

export default Home;